import { render } from "./rating.vue?vue&type=template&id=1fe3d226"
import script from "./rating.vue?vue&type=script&lang=js"
export * from "./rating.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__